import { initContract } from '@ts-rest/core';
const c = initContract();
export const chatContract = c.router({
    createChat: {
        method: 'POST',
        path: '/chats',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getMessages: {
        method: 'GET',
        path: '/chats/:id/messages',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getChatById: {
        method: 'GET',
        path: '/chats/:id',
        responses: {
            200: c.type(),
        },
    },
    getChats: {
        method: 'GET',
        path: '/chats',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateChat: {
        method: 'PATCH',
        path: '/chats/:id',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    deleteChat: {
        method: 'DELETE',
        path: '/chats/:id',
        responses: {
            200: c.type(),
        },
    },
    getChatConfig: {
        method: 'GET',
        path: '/chats/:id/config',
        responses: {
            200: c.type(),
        },
    },
    findTextMatch: {
        method: 'POST',
        path: '/chats/text-matching',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    refinePrompt: {
        method: 'POST',
        path: '/assistant/refine-prompt',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    scoreResponse: {
        method: 'POST',
        path: '/chats/score-answer',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
});
//# sourceMappingURL=chat.js.map